import React, { useState } from "react";
import { PageProps } from "gatsby";
import {
  Card,
  CardActions,
  CardContent,
  Collapse,
  Grid,
  Icon,
  IconButton,
  Typography,
} from "@mui/material";
import { Theme } from "@mui/material/styles";
import { ExpandMore } from "@mui/icons-material";
import { useSidebar, Link, NavLink } from "../utils";

const styles = {
  mt2: {
    marginTop: 2,
  },
  mr1: {
    marginRight: 1,
  },
  pb0: {
    paddingBottom: 0,
  },
  fullHeight: {
    height: "100%",
  },
  title: {
    fontSize: 16,
    display: "flex",
    justifyContent: "left",
    marginBottom: 2,
  },
  actionGroup: {
    display: "flex",
    justifyContent: "flex-end",
    padding: (theme: Theme) => theme.spacing(0, 2, 2, 2),
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: (theme: Theme) =>
      theme.transitions.create("transform", {
        duration: theme.transitions.duration.shortest,
      }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
};

function ModuleCard({ module }: { module: NavLink }) {
  const collapseThreshold = 4,
    hasCollapse = module.items.length > collapseThreshold;
  const [open, setOpen] = useState(false);
  return (
    module.items && (
      <Card sx={styles.fullHeight}>
        <CardContent sx={hasCollapse ? styles.pb0 : null}>
          <Typography sx={styles.title}>
            {module.icon && <Icon sx={styles.mr1}>{module.icon}</Icon>}
            {module.label}
          </Typography>
          {module.items.slice(0, collapseThreshold).map((child, index) => (
            <Typography key={index}>
              <Link to={child.link}>{child.label}</Link>
            </Typography>
          ))}
          {hasCollapse && (
            <Collapse in={open} timeout="auto" unmountOnExit>
              {module.items.slice(collapseThreshold).map((child, index) => (
                <Typography key={index}>
                  <Link to={child.link}>{child.label}</Link>
                </Typography>
              ))}
            </Collapse>
          )}
        </CardContent>
        {hasCollapse && (
          <CardActions sx={styles.actionGroup}>
            <IconButton
              size="small"
              aria-expanded={open}
              aria-label="show more"
              onClick={() => setOpen(!open)}
              sx={{ ...styles.expand, ...(open && styles.expandOpen) }}
            >
              <ExpandMore />
            </IconButton>
          </CardActions>
        )}
      </Card>
    )
  );
}

const Home: React.FC<PageProps> = function Home() {
  const modules = useSidebar();

  return (
    <main>
      <Grid container spacing={2} sx={styles.mt2}>
        {modules
          .filter((m) => m.items)
          .map((module, index) => (
            <Grid item xs={12} md={6} lg={4} key={index}>
              <ModuleCard module={module} />
            </Grid>
          ))}
      </Grid>
    </main>
  );
};

export default Home;
